import React from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';

interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBox: React.FC<SearchBoxProps> = ({ value, onChange, placeholder = 'חיפוש...' }) => {
  return (
    <div style={{
      position: 'relative',
      width: '100%',
      marginBottom: '15px',
      direction: 'rtl'
    }}>
      {!value && (<FaSearch style={{
        position: 'absolute',
        left: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#6c757d',
        zIndex: 1
      }} />)}
      
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          padding: '8px 10px',
          fontSize: '16px',
          color: 'var(--page-font-color)',
          border: '1px solid #1FB5A3',
          borderRadius: '100px',
          outline: 'none' // Removes the default focus outline
        }}
        onFocus={(e) => {
          e.target.style.border = '2px solid #1FB5A3'; // Custom focus border
          e.target.style.boxShadow = '0 0 0 2px rgba(31, 181, 163, 0.2)'; // Optional: adds a subtle glow
        }}
        onBlur={(e) => {
          e.target.style.border = '1px solid #1FB5A3'; // Reset to original border on blur
          e.target.style.boxShadow = 'none'; // Remove shadow on blur
        }}
      />
      
      {value && (
        <FaTimes 
          onClick={() => onChange('')}
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#6c757d',
            cursor: 'pointer',
            zIndex: 1
          }}
        />
      )}
    </div>
  );
};

export default SearchBox;